import React from 'react';
import './LoadingSpinner.css';

function LoadingSpinner() {
  return (
    <div className="loading-spinner">
      <div className="spinner"></div>
      <p>読み込み中...</p>
    </div>
  );
}

export default LoadingSpinner;
